export var linearProgressTheme = {
  baseStyle: _ref => {
    var {
      percentage,
      isFullWidth
    } = _ref;
    return {
      container: {
        backgroundColor: 'neutral.light',
        overflow: 'hidden',
        width: '100%',
        maxWidth: isFullWidth ? '100%' : '120px',
        height: '8px',
        borderRadius: 'm'
      },
      track: {
        backgroundColor: 'brand.main',
        width: "".concat(percentage, "%"),
        height: '100%',
        transition: 'width 0.6s ease'
      }
    };
  }
};
//# sourceMappingURL=LinearProgressTheme.js.map